/* eslint-disable */
import RestTypeFactory from "@/js/common/Domain/Factory/RestType";

let RestTypeRussiaFactory = function(data) {
	var restType = new RestTypeFactory(data.name, data.id),
		element;

	element = data['name_en'];
	if(typeof element != "undefined") {
		restType.set('nameEn', element);
	}
	
	element = data['description'];
	if(typeof element != "undefined") {
		restType.set('description', element);
	}
	
	return restType;
};

export default RestTypeRussiaFactory;